import React from 'react'
import { Modal, Tabs } from 'antd'
import InvoicesTab from './InvoicesTab'
import StoTab from './StoTab'

interface PaymentsDataProps {
    visible: boolean
    onClose: () => void
    clientId: number | string
    email: string
    firstName: string
    lastName: string
    identity: string
    roles: string[]
    userIsCollective?: string
}

interface PaymentsDataState {
    activeTab: string
}

class PaymentsData extends React.Component<PaymentsDataProps, PaymentsDataState> {
    state: PaymentsDataState = {
        activeTab: 'invoices' //'invoices'
    }

    handleTabChange = (activeKey: string) => {
        this.setState({ activeTab: activeKey })
    }

    render() {
        const { visible, onClose, clientId, email, firstName, lastName, identity, roles, userIsCollective } = this.props
        const { activeTab } = this.state
        const hasAcceptedRole = roles.includes('admin') || roles.includes('money')

        return (
            <Modal
                visible={visible}
                footer={null}
                onCancel={onClose}
                width="95vw"
                style={{ top: 20 }}
                bodyStyle={{
                    height: '90vh',
                    overflow: 'auto',
                    padding: 24
                }}
                closeIcon={<span style={{ fontSize: 24, lineHeight: 1 }}>×</span>}
                destroyOnClose
            >
                {/* Header: client info centered, tabs right-aligned */}
                <div style={{ marginBottom: 24 }}>
                    {/* Client Info (centered) */}
                    <div style={{ textAlign: 'center', direction: 'rtl', marginBottom: 12 }}>
                        <div style={{ fontSize: 18, fontWeight: 500 }}>
                            {firstName} {lastName} <span style={{ color: '#999' }}>({clientId})</span>{' '}
                            {userIsCollective ? (
                                <span style={{ color: '#1890ff', fontSize: 14, fontWeight: 'normal' }}>קולקטיב</span>
                            ) : null}
                        </div>
                        <div style={{ fontSize: 14, color: '#555' }}>ת"ז: {identity}</div>
                        <div style={{ fontSize: 14, color: '#555' }}>{email}</div>
                    </div>

                    {/* Tabs (right-aligned and LTR so the underline works correctly) */}
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                        <Tabs activeKey={activeTab} onChange={this.handleTabChange} tabBarStyle={{ marginBottom: 0 }}>
                            {/* <Tabs.TabPane tab="היסטוריית עסקאות" key="transactions" /> */}
                            <Tabs.TabPane tab="חשבוניות" key="invoices" />
                        </Tabs>
                        {hasAcceptedRole ? (
                            <Tabs
                                activeKey={activeTab}
                                onChange={this.handleTabChange}
                                tabBarStyle={{ marginBottom: 0 }}
                            >
                                <Tabs.TabPane tab="חיובים" key="sto" />
                            </Tabs>
                        ) : null}
                    </div>
                </div>

                {/* Tab content */}
                {activeTab === 'invoices' && (
                    <div>
                        <InvoicesTab userId={clientId} userIsCollective={userIsCollective} />
                        {/* <div>TEST COMPONENT</div> */}
                    </div>
                )}
                {activeTab === 'transactions' && <div>{/* היסטוריית עסקאות content goes here */}</div>}
                {activeTab === 'sto' && <StoTab userId={clientId} roles={roles} userIsCollective={userIsCollective} />}
            </Modal>
        )
    }
}

export default PaymentsData
